import { render, staticRenderFns } from "./GenericControlThreat.vue?vue&type=template&id=afbffaa0&scoped=true&"
import script from "./GenericControlThreat.vue?vue&type=script&lang=js&"
export * from "./GenericControlThreat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbffaa0",
  null
  
)

export default component.exports